// extracted by mini-css-extract-plugin
export default {"light":"styles_light__ZO4zt","followUs":"styles_followUs__AT35S","title":"styles_title__EU-ts","testBackground":"styles_testBackground__no5DQ","iframe":"styles_iframe__mo-ws"};